<template>
  <div class="terms p-8 vs-con-loading__container border border-solid rounded-lg d-theme-border-grey-light">
    <div class="vx-row">
      <div class="vx-col w-full items-center">
        <vs-button v-if="hasRole('add_terms')" @click="openForm" class="mb-base ml-auto lg:w-auto w-full" color="success" icon-pack="feather" icon="icon-plus" icon-after>إضافة فصل</vs-button>
      </div>
      <div v-for="term in terms" :key="term.id" class="vx-col lg:w-1/3 w-full mb-base" >
        <vx-card :title="term.name">
          <div slot="actions">
            <vs-chip v-if="term.is_active" color="primary">الفصل الحالي</vs-chip>
          </div>
          <div class="h-24"></div>
          <div slot="footer">
            <vs-button :to="{ name: 'adminTerm', params: { term_id: term.id } }"
                       class="ml-auto lg:w-auto w-full"
                       icon="icon-chevrons-left" icon-pack="feather" icon-after>عرض الفصل</vs-button>
          </div>
        </vx-card>
      </div>
    </div>

    <term-form @submit="save" :data="termData" :active.sync="isFormActive" />
  </div>
</template>

<script>

    import TermForm from '@/views/admin/TermForm'
    import termsAPI from '@/api/admin/termsAPI'

    export default {
        name: 'terms',
        components: { TermForm },
        data() {
            return {
                terms: [],
                termData: {},
                termEditIndex: -1,
                isFormActive: false,
            }
        },
        methods: {
            openForm(data = {}){
                Object.assign(this.termData = {}, data)
                this.termEditIndex = this.terms.indexOf(data)
                this.isFormActive = true
            },
            save(data){
                this.termEditIndex !== -1 ? this.$set(this.terms, this.termEditIndex, data) : this.terms.unshift(data)
            },
            loadData(){
              this.$startLoading('.terms', 'white')
              termsAPI.getAll().then(({data}) => {
                this.terms = data.terms
              }).finally(() => this.$closeLoading('.terms'))
            }
        },
        mounted() {
            this.loadData()
        },
    }

</script>
